<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4MjGdF/media/FC-9781649799746.jpg?1692049823873" alt="This image is the cover for the book American Dysfunction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Dysfunction
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Cambria",serif;color:black;'>Alex Walker just wants to find peace. Growing up in a dysfunctional blue-collar family, he learns to navigate life, carrying heavy emotional baggage from years of abuse and neglect.</span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><br/></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Cambria",serif;color:black;'>Trouble follows Alex through the hills of suburban Philadelphia to a rural trade school, where he travels down a dark path. </span></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><br/></p><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;margin:0cm;margin-bottom:.0001pt;text-align:justify;background:white;'><span style='font-family:"Cambria",serif;color:black;'>While on probation, Alex joins a ragtag 90s cover band which teaches him that life doesn’t have to be so dramatic. </span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan Rex
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Ryan&rsquo;s legacy comes from generations of plumbers and mechanical tradesmen. Growing up in a small business, and surrounded by colorful people has shaped Ryan into the person he is today. Discovering his love of writing while in college, Ryan used any and all spare time to develop his creative works, which would one day become more than just a dream.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64bdff14